import Container from "@components/Container";
import MinimalHeaderNav from "@components/MinimalHeader/MinimalHeaderNav";
import NavBarLogo from "@components/NavBar/NavBarLogo";
import TopBar from "@components/SiteShell/TopBar";
import { toTopBarItems } from "@components/SiteShell/TopBar/items";
import { Partner } from "@justhome/api-core";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import { FC } from "react";

interface MinimalHeaderProps {
  border?: boolean;
  onContactClick?: VoidFunction;
  showTopBar?: boolean;
  partner?: Partner;
}

const MinimalHeader: FC<MinimalHeaderProps> = ({
  border,
  partner,
  onContactClick,
  showTopBar = true,
}) => {
  const { t } = useTranslation("homepage-v2");

  return (
    <header
      className={clsx("flex flex-col bg-neutral-0", {
        "border-b border-b-neutral-25": border,
      })}
    >
      {showTopBar && <TopBar items={toTopBarItems(t)} fullWidth />}
      <Container fullWidth padding className="flex h-xl items-center">
        <NavBarLogo
          className="justify-center m:justify-start"
          partner={partner}
        />
        <MinimalHeaderNav onContactClick={onContactClick} />
      </Container>
    </header>
  );
};

export default MinimalHeader;
